import { useRef } from 'react';
import { Semester, SemesterCourse } from '../../api/requests/curriculum';
import ModalValidationTypeInfo, {
  ModalValidationTypeInfoRef,
} from './parts/ModalValidationTypeInfo';
import ProgressionBySemester from './parts/ProgressionBySemester';
import { CoursesBySemestersExtraCourse } from './validation-type';

type ProgressionBySemesterProps = {
  semesters: Semester[];
  extraCourses?: CoursesBySemestersExtraCourse[];
};

const ProgressionBySemesters = ({
  semesters,
  extraCourses,
}: ProgressionBySemesterProps) => {
  const modalValidationTypeInfoRef = useRef<
    ModalValidationTypeInfoRef | undefined
  >();
  const onClickShow = (row: SemesterCourse) => {
    modalValidationTypeInfoRef.current?.openModal(row);
  };

  return (
    <>
      <div
        className="g-progression d-flex w-100"
        style={{
          overflowX: 'auto',
          flexDirection: 'row',
          gap: 16,
          marginLeft: -16,
          marginRight: -16,
          paddingBottom: 16,
          paddingRight: 16,
          paddingLeft: 16,
        }}
      >
        {semesters.map((semester, index) => (
          <ProgressionBySemester
            key={`semester_${semester.id}`}
            {...semester}
            title={
              semester.title ? semester.title : `${semester.semesterIndex}`
            }
            onClickInfoModal={onClickShow}
            extraCourses={
              semesters.length - 1 === index ? extraCourses : undefined
            }
          />
        ))}
      </div>
      <ModalValidationTypeInfo
        ref={
          modalValidationTypeInfoRef as React.Ref<ModalValidationTypeInfoRef>
        }
      />
    </>
  );
};

export default ProgressionBySemesters;
